import { marker } from '@jsverse/transloco-keys-manager/marker';
import { ExperienceTagBE } from '@shared/models/be-experience.model';
import { Tag, TagColor, TagIcon } from '@shared/models/tag.model';

export const EXPERIENCE_TAGS_KEYS: Record<ExperienceTagBE, string> = {
  tag_area: marker('experience.tagArea'),
  tag_best_for: marker('experience.tagBestFor'),
  tag_great_for: marker('experience.tagGreatFor'),
  tag_price: marker('experience.tagPrice'),
  tag_style: marker('experience.tagStyle'),
  tag_type: marker('experience.tagType'),
  tag_vibe: marker('experience.tagVibe'),
  tag_way: marker('experience.tagWay'),
};

export const BENEFITS_TAG: Tag = {
  color: TagColor.BENEFITS,
  icon: TagIcon.BENEFITS,
  textKey: marker('itinerary.exclusiveBenefits'),
};
